import { PanelSize } from 'react-resizable-panels';

export const DETAILS_EXPANSION_STEPS = 3;

interface GetDetailsExpansionStepsParams {
  size: PanelSize;
  minSizeInPixels: number;
  maxSizeRatio: number;
}

export const getDetailsExpansionSteps = ({
  size,
  minSizeInPixels,
  maxSizeRatio,
}: GetDetailsExpansionStepsParams): number => {
  if (size.asPercentage <= 0) {
    return 0;
  }

  const groupSizeInPixels = (size.inPixels * 100) / size.asPercentage;
  const expansionRange = groupSizeInPixels * maxSizeRatio - minSizeInPixels;

  if (expansionRange <= 0) {
    return 0;
  }

  const expansionRatio = (size.inPixels - minSizeInPixels) / expansionRange;
  const steps = Math.floor(expansionRatio * DETAILS_EXPANSION_STEPS);

  return Math.min(DETAILS_EXPANSION_STEPS, Math.max(0, steps));
};
